/*
 * LARGO — corrige l'empilement (z-index) entre le menu mobile natif
 * et les éléments flottants/sticky de la page (bouton WhatsApp, barre
 * d'achat sticky, bouton COD flottant injecté par une app comme Releasit).
 *
 * Le menu mobile est un composant natif du thème (header-component),
 * dont l'implémentation interne n'est pas un fichier Liquid/CSS de ce
 * thème custom — impossible à cibler avec certitude par un simple
 * z-index. Solution robuste : détecter l'ouverture de N'IMPORTE QUEL
 * tiroir/dialogue/menu via plusieurs signaux, et masquer temporairement
 * les éléments flottants pendant qu'il est ouvert. Rien n'est masqué
 * de façon permanente — tout revient dès la fermeture du menu.
 */
(function () {
  var LOCK_CLASSES = [
    'overflow-hidden',
    'no-scroll',
    'menu-open',
    'drawer-open',
    'js-drawer-open',
    'scroll-lock',
  ];

  function isMenuOpen() {
    var headerGroup = document.getElementById('header-group');
    if (headerGroup && headerGroup.querySelector('[open]')) return true;
    if (document.querySelector('header-component [aria-expanded="true"]')) return true;
    for (var i = 0; i < LOCK_CLASSES.length; i++) {
      if (document.documentElement.classList.contains(LOCK_CLASSES[i])) return true;
      if (document.body.classList.contains(LOCK_CLASSES[i])) return true;
    }
    return false;
  }

  function sync() {
    document.documentElement.classList.toggle('lg-menu-open', isMenuOpen());
  }

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  var mo = new MutationObserver(sync);
  mo.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open', 'class', 'aria-expanded'],
    subtree: true,
  });

  // Filet de sécurité : un clic dans l'en-tête (bouton menu) peut déclencher
  // une ouverture avant que l'attribut ne soit posé — on revérifie juste après.
  var headerGroupEl = document.getElementById('header-group');
  if (headerGroupEl) {
    headerGroupEl.addEventListener('click', function () {
      setTimeout(sync, 30);
      setTimeout(sync, 200);
    });
  }
})();
